import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-crm-owned-contact-icon',
    templateUrl: './crm-owned-contact-icon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CrmOwnedContactIconComponent {
    @Input() type: 'Company' | 'Contact';
    @Input() recordUrl: string;
    @Input() vendor: 'salesforce' | 'hubspot' = 'salesforce';
}
